/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import Vue from 'vue';
import VueRouter, { RouterOptions } from 'vue-router';
import { ConfigurationPluginManager } from '../plugins/configuration';
import { store } from '../store';
import { routes } from './config';
import { useRouterMiddleware } from './routerFeatures';
import RouteNames from './routes';

Vue.use(VueRouter);

const router: VueRouter = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {
  const middleware = useRouterMiddleware(to);
  // @TODO: we need to fetch the customer through the API if we want a SPA after each route change
  // --- set document title if provided in routing
  if (middleware.providesTitle()) {
    middleware.setDocumentTitle();
  }

  // --- supply customer from configuration to store if not done already
  if (!middleware.isAuthenticated()) {
    middleware.commitAuthWithConfigPlugin(ConfigurationPluginManager.getInstance());
  }

  // if (middleware.isAuthRequired() && !middleware.isAuthenticated()) {
  //   // --- this is for the future SPA,
  //   // here we can redirect the customer to the login form component
  // }

  // --- check if the currentRoute needs an admin flag set and if the customer is an admin
  if (middleware.isAdminRoute()) {
    if (!store.getters['auth/isAdmin']) {
      next({ name: RouteNames.NotFound });
    } else {
      next();
    }
    return;
  }

  next();
});

export { router };
export const useRouter = () => router;
